
<template>
  <div class="onboard column">
    <div class="logo row align-center">
      <div class="grid-6 first hide-s">PRIMEIRO ACESSO</div>
      <div class="grid-6 grid-12-s row justify-center-s justify-end">
        <img src="../../assets/img/logo-supporter.png" alt="Logo NetSupport" />
      </div>
    </div>
    <div class="head row align-center">
      <div class="lia">
        <img src="../../assets/img/lia.jpeg" alt="Lia" />
      </div>

      <div class="name column grid-2">
        LIA
        <div class="status">ASSISTENTE VIRTUAL</div>
      </div>
      <div class="text-right grid-9">
        <Button v-if="context.step < 6" layout="green-s" @click="reset" style="border: none"><b>RECOMEÇAR</b></Button>
        &nbsp;
      </div>
    </div>

    <div id="container">
      <div class="message row" :class="context.step > 0 ? '' : 'outside'">
        <div class="left">
          Seja bem vindo <b>SUPPORTER PARCEIRO.</b><br /><br />

          Para começar a realizar <b>ATENDIMENTOS</b> é necessário que informe
          alguns dados sobre a <b>SUA EMPRESA:</b>
        </div>
      </div>

      <!--  <div class="message" :class="context.step > 1 ? '' : 'outside'">
        <div class="left">
          O primeiro passo é ler e concodar com os
          <b>TERMOS DE USO</b> da plataforma: <br /><br />
          <span
            v-if="(context.step > 2 && !context.skips.term) || context.agree"
            class="info"
          >
            <i class="fa fa-check" /> Ótimo!
          </span>
          <div
            class="row justify-space align-center"
            v-if="context.step == 2 && !context.agree"
          >
            <Button layout="green-go" @click="context.modal.show = true"
              ><i class="fa fa-file-text" /> TERMOS DE USO</Button
            >
            <Button layout="remote-skip" @click="skip()">LER DEPOIS</Button>
          </div>
        </div>
      </div> 
    

      <div class="message" v-if="context.skips.term && context.step > 2">
        <div class="right">Ler depois</div>
      </div>

      <div
        class="message skip"
        :class="context.skips.term && context.step > 2 ? '' : 'outside'"
      >
        <div class="left row column-s align-center justify-space">
          <p>
            Tudo bem, depois você poderá resolver<br />essa <b>PENDÊNCIA</b> no
            menu Pendências.
          </p>
          <img src="../../assets/img/pendencias.png" width="200" />
        </div>
      </div>
-->
      <div class="message" :class="context.step > 2 ? '' : 'outside'">
        <div class="left">
          Todo <b>SUPPORTER PARCEIRO</b> possui sua conta associada a um CNPJ.
          <br /><br />
          <div class="row justify-space align-center">
            <b>Informe o CNPJ da sua empresa:</b>
            <Button layout="remote-skip" @click="skip()" v-if="context.step == 3">INFORMAR DEPOIS
            </Button>
          </div>
        </div>
      </div>

      <div class="message" v-if="context.skips.cnpj">
        <div class="right">Informar depois</div>
      </div>

      <div class="message skip" :class="context.skips.cnpj ? '' : 'outside'">
        <div class="left row column-s align-center justify-space">
          <p>
            Tudo bem, depois você poderá resolver<br />essa <b>PENDÊNCIA</b> no
            menu Pendências.
          </p>
          <img src="../../assets/img/pendencias.png" width="200" />
        </div>
      </div>

      <div class="message" v-if="context.form.cnpj">
        <div class="right">{{ context.form.cnpj | cnpj }}</div>
      </div>

      <template v-if="!context.hideCPF">
        <div class="message row" :class="context.step > 3 ? '' : 'outside'">
          <div class="left">
            Muito bem, agora informe o<br />

            <div class="row justify-space align-center">
              <b> CPF do titular da empresa:</b>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Button layout="remote-skip" @click="skip()" v-if="context.step == 4">INFORMAR DEPOIS
              </Button>
            </div>
          </div>
        </div>

        <div class="message" v-if="!context.skips.cnpj && context.skips.cpf">
          <div class="right">Informar depois</div>
        </div>

        <div class="message skip" :class="context.skips.cpf ? '' : 'outside'">
          <div class="left row column-s align-center justify-space">
            <p>
              Tudo bem, depois você poderá resolver<br />essa
              <b>PENDÊNCIA</b> no menu Pendências.
            </p>
            <img src="../../assets/img/pendencias.png" width="200" />
          </div>
        </div>
      </template>

      <!--  // INPUT ERRORS -->
      <div class="message" v-for="(e, i) in context.error" :key="'erro' + i" :class="e.skip">
        <div v-if="e.left && e.left == 'cnpj'" class="left">
          Todo <b>SUPPORTER PARCEIRO</b> possui sua conta associada a um CNPJ.
          <br /><br />
          <div class="row justify-space align-center">
            <b>Informe o CNPJ da sua empresa:</b>
            <Button layout="remote-skip" @click="skip()" v-if="context.step == 3">INFORMAR DEPOIS
            </Button>
          </div>
        </div>

        <div v-if="e.left && e.left == 'cnpj' && context.skips.cnpj"
          class="left skip row column-s align-center justify-space">
          <p>
            Tudo bem, depois você poderá resolver<br />essa <b>PENDÊNCIA</b> no
            menu Pendências.
          </p>
          <img src="../../assets/img/pendencias.png" width="200" />
        </div>

        <div v-if="e.left && e.left == 'cpf'" class="left">
          Muito bem, agora informe o<br />
          <div class="row justify-space align-center">
            <b> CPF do titular da empresa:</b>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Button layout="remote-skip" @click="skip()" v-if="context.step == 4">INFORMAR DEPOIS
            </Button>
          </div>
        </div>

        <div v-if="e.left && e.left == 'cpf' && context.skips.cpf"
          class="skip left row column-s align-center justify-space">
          <p>
            Tudo bem, depois você poderá resolver<br />essa <b>PENDÊNCIA</b> no
            menu Pendências.
          </p>
          <img src="../../assets/img/pendencias.png" width="200" />
        </div>

        <!-- CPF & CNPJ -->
        <div class="right" v-if="e.right && e.right == 'cpf'">
          {{ context.form.cpf | cpf }}
        </div>

        <div class="right" v-if="e.right && e.right == 'cnpj'">
          {{ context.form.cnpj | cnpj }}
        </div>

        <!-- NORMAL -->
        <div class="right" v-if="e.right && e.right !== 'cpf' && e.right !== 'cnpj'">
          {{ e.right }}
        </div>

        <div class="error left" v-if="e.left && e.left !== 'cpf' && e.left !== 'cnpj'">
          {{ e.left }}
        </div>
      </div>

      <!-- // ERROR END -->

      <div class="message row" :class="context.step > 4 ? '' : 'outside'">
        <div class="left">
          Legal, agora preciso de um documento pessoal do titular da empresa.<br />
          Pode ser <b>RG</b> ou <b>CNH</b><br />
          <span v-if="context.step > 5 && !context.skips.doc" class="info">
            <i class="fa fa-check" /> <b>OK.</b>
          </span>
          <div class="row justify-space align-center options" v-if="context.step == 5">
            <div class="row">
              <Button layout="green-go" @click="showModalFile()">ENVIAR</Button>
            </div>
            <Button layout="remote-skip" @click="skip()">ENVIAR DEPOIS</Button>
          </div>
        </div>
      </div>

      <div class="message" v-if="context.skips.doc">
        <div class="right">Enviar depois</div>
      </div>

      <div class="message" v-if="context.midia.doc">
        <div class="right">
          <img v-if="context.midia.doc" :src="context.midia.doc" />
        </div>
      </div>
      <template v-if="!context.hideLive">
        <div class="message row" :class="context.step > 5 ? '' : 'outside'">
          <div class="left">
            E por último, nos envie uma
            <b>FOTO DE ROSTO SEGURANDO O DOCUMENTO</b> enviado anteriormente.<br />

            <span v-if="context.step > 6 && !context.skips.live" class="info">
              <i class="fa fa-check" /> <b>OK.</b>
            </span>
            <div class="row justify-space align-center options" v-if="context.step == 6">
              <Button layout="green-go" @click="context.modalFile.show = true"><i class="fa fa-id-card" /> ENVIAR
                FOTO</Button>
              <Button layout="remote-skip" @click="skip()">ENVIAR DEPOIS</Button>
            </div>
          </div>
        </div>
        <div class="message" v-if="context.midia.live">
          <div class="right">
            <img v-if="context.midia.live" :src="context.midia.live" />
          </div>
        </div>
        <div class="message" v-if="context.skips.live">
          <div class="right">Enviar depois</div>
        </div>
      </template>
      <div class="message skip" :class="context.step > 6 ? '' : 'outside'">
        <div class="left row column-s justify-space">
          <p class="text-center-s">
            <b class="info"><i class="fa fa-check" /> PRONTO!</b><br /><br />
            <b>Você poderá acompanhar a análise de seus documentos no menu
              Pendências.</b>
            <img src="../../assets/img/pendencias.png" width="200" class="hide-m hide-g" />
            <br />Agora você já pode acessar a plataforma NetSupport:
            <br /><br />
            <label class="row-s justify-center-s">
              <a href="/supporter/dashboard">
                <Button layout="green-m"><i class="fa fa-rocket" /> IR PARA PLATAFORMA</Button>
              </a>
            </label>
          </p>
          <img src="../../assets/img/pendencias.png" width="200" class="hide-s" />
        </div>
      </div>
    </div>

    <!-- // CONTROLS -->
    <div class="buttons row" :class="context.placeholder ? '' : 'out'">
      <input class="input grid-9" type="text" v-model="context.input" :placeholder="context.placeholder"
        @keyup.enter="send()" v-mask="context.mask" />
      <i class="fas fa-paper-plane" title="ENVIAR" @click="send()" />
    </div>

    <Modal :modal="context.modal" />
    <Modal :modal="context.modalFile" />
  </div>
</template>


<script>
import Vue from "vue";
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import format from "@/utils/format";

import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

var context = {
  loader: false,
  input: "",
  hideCPF: false,
  hideLive: false,
  invalid: false,
  agree: false,
  midia: { doc: "", live: "" },
  form: { cnpj: "", cpf: "" },
  step: 0,
  mask: "",
  placeholder: "",
  error: [],
  skips: { term: false, cnpj: false, doc: false, live: false },
  modal: {
    layout: "Termo",
    show: false,
  },
  modalFile: {
    title: "Enviar documento pessoal",
    show: false,
    layout: "Files",
    pendency: {
      tipo_arquivo: "1_id_doutor",
      subtipos_arquivo: [
        { identificador: "cnh", nome: "CNH" },
        { identificador: "rg", nome: "RG" },
      ],
    },
  },
};

export default {
  name: "Onboarding",
  components: {
    Button,
    Modal,
  },
  data() {
    return {
      context: context,
    };
  },
  methods: {
    ...mapActions("user", ["LOAD_DOCS", "PUT_DOCS", "GET_SESSION"]),
    callbacks() {
      this.context.modalFile.cb = (midia) => {
        if (this.context.modalFile.pendency.tipo_arquivo == "1_id_doutor")
          this.context.midia.doc = midia;
        else this.context.midia.live = midia;

        this.context.modalFile.pendency.tipo_arquivo = "4_self_doutor_doc";
        this.context.modalFile.title = "FOTO DE ROSTO SEGURANDO O DOCUMENTO";
        this.context.modalFile.show = false;
        this.context.step++;
        this.scroll();
        this.save();
      };

      this.context.modal.cb = () => {
        this.context.agree = true;
        this.scroll();
        this.context.step++;
        const self = this;
        if (this.context.step == 3)
          setTimeout(function () {
            self.showInput("cnpj");
          }, 500);
        this.save();
      };
    },
    save() {
      localStorage.setItem("onboarding", JSON.stringify(this.context));
    },
    reset() {
      if (confirm("Tem certeza que deseja recomeçar?")) {
        /* delete localStorage.onboarding; */
        this.context.step = 0;
        if (this.context.agree || this.context.skips.term)
          this.context.step = 1;

        this.context.error = [];
        this.context.form = context.form;
        this.context.midia = context.midia;
        this.context.skips = context.skips;
        this.context.invalid = false;

        this.start();
      }
    },
    scroll() {
      setTimeout(function () {
        let objDiv = document.getElementById("container");
        objDiv.scrollTo({
          top: objDiv.scrollHeight,
          behavior: "smooth",
        });
      }, 600);
    },
    showModalFile() {
      this.context.modalFile.show = true;
    },
    showInput(type) {
      const self = this;
      if (type == "cnpj") {
        setTimeout(function () {
          self.context.input = "";
          self.context.mask = "##.###.###/####-##";
          self.context.placeholder = "Digite aqui o seu CNPJ";
          self.scroll();
          self.save();
        }, 500);
      }

      if (type == "cpf") {
        setTimeout(function () {
          self.context.mask = "###.###.###-##";
          self.context.input = "";
          self.context.placeholder = "Digite o CPF do titular da empresa";
          self.scroll();
          self.save();
        }, 500);
      }

      if (type == "hide") {
        setTimeout(function () {
          self.context.mask = "";
          self.context.placeholder = "";
          self.context.input = "";
          self.scroll();
          self.save();
        }, 500);
      }
    },
    start() {
      const self = this;
      self.context.step++;
      setTimeout(function () {
        self.context.step++;
        self.scroll();
        setTimeout(function () {
          self.context.step++;
          self.showInput('cnpj')
        }, 500);
      }, 700);
      this.callbacks();
    },
    skip() {
      const self = this;

      //TERMO
      if (this.context.step == 2) {
        this.context.skips.term = true;
        this.context.step++;
        this.scroll();
        setTimeout(function () {
          self.showInput("cnpj");
        }, 700);
        return;
      }

      //CNPJ
      if (this.context.step == 3) {
        this.context.hideCPF = true;
        if (this.context.invalid)
          this.context.error.push({ right: "Informar depois" });

        this.showInput("hide");
        this.context.skips.cnpj = true;
        this.context.skips.cpf = true;
        this.context.step++;
        this.context.step++;
        this.scroll();
        this.save();

        return;
      }

      //CPF
      if (this.context.step == 4) {
        this.context.skips.cpf = true;
        if (this.context.invalid)
          this.context.error.push({ right: "Informar depois" });
        this.context.step++;
        this.scroll();
        setTimeout(function () {
          self.showInput("hide");
        }, 700);
        return;
      }

      //DOC PESSOAL
      if (this.context.step == 5) {
        this.context.skips.doc = true;
        this.context.skips.live = true;
        this.context.hideLive = true;
        this.context.step++;
        this.context.step++;
        this.scroll();
        this.save();
        return;
      }

      //DOC LIVE
      if (this.context.step == 6) {
        this.context.skips.live = true;
        this.context.step++;
        this.scroll();
        this.save();
        return;
      }
    },
    send() {
      /* CPF */
      if (this.context.step == 3) {
        this.context.form.cnpj = this.context.input;

        if (this.context.invalid) {
          this.context.error.push({ right: "cnpj" });
          this.context.error.push({ left: "cpf" });
        }
        this.context.mask = "###.###.###-##";
        this.context.placeholder = "Digite o CPF do titular da empresa";
        this.context.input = "";
        this.context.step++;
        this.showInput("cpf");
        this.scroll();
        this.save();

        return;
      }

      /* CNPJ */
      if (this.context.step == 4) {
        this.context.form.cpf = this.context.input;
        this.context.error.push({ right: this.context.input });

        //CHAMAR API
        let form = {
          cpf: format.clear(this.context.form.cpf),
          cnpj: format.clear(this.context.form.cnpj),
        };

        this.LOAD_DOCS().then(({ data: { etag } }) => {
          form.etag = etag;
          this.PUT_DOCS(form)
            .then((data) => {
              if (data.status != 200) {
                this.context.step = 3;
                this.context.invalid = true;
                this.context.error.push({ left: data.data.msg });
                this.context.error.push({ left: "cnpj" });
                this.showInput("cnpj");
                this.context.form = context.form;
              } else {
                this.context.step++;
                this.context.invalid = false;
                this.showInput("hide");
              }
              this.scroll();
              this.save();
            })
            .catch((data) => {
              if (data.data && data.data.msg)
                this.context.error.push({ left: data.data.msg });
            });
        });

        return;
      }
    },
  },
  beforeMount() {
    if (localStorage.getItem("onboarding")) {
      this.context = JSON.parse(localStorage.getItem("onboarding"));
    }
  },
  mounted() {
    if (!localStorage.getItem("onboarding")) {
      this.start();
    } else {
      this.context = JSON.parse(localStorage.getItem("onboarding"));
      this.scroll();
    }
    this.callbacks();
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.onboard {
  height: 80vh;

  .logo {
    padding: 6px 12px;
    background: black;

    .first {
      font-size: 16px;
      color: $white-3;
      letter-spacing: 3px;
    }

    img {
      width: 190px;
      margin-top: 2px;
    }
  }

  .head {
    background: $font-color;
    font-size: 33px;
    font-weight: bold;
    letter-spacing: 3px;
    color: white;
    padding: 8px;
    padding-left: 30px;
    margin-bottom: 28px;
    box-shadow: $shadow;

    @media (max-width: $small) {
      padding-top: 5px;
    }

    .lia {
      width: 84px;
      height: 86px;

      @media (max-width: $small) {
        width: 64px;
        height: 70px;
      }

      img {
        width: 84px;
        border-radius: 50%;
        box-shadow: $shadow;
        border: 3px inset $supporter-1;
        position: fixed;
        top: 60px;

        @media (max-width: $small) {
          width: 64px;
        }
      }
    }

    .name {
      margin-left: 30px;

      @media (max-width: $small) {
        font-size: 30px;
      }
    }

    .status {
      font-size: 16px;
      margin-top: 9px;
      color: $supporter-1;
      letter-spacing: 2px;

      @media (max-width: $small) {
        font-size: 14px;
      }
    }
  }

  #container {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 60px;
  }

  .button-green-m {
    background: $supporter-1;
  }

  .message {
    width: 100%;
    color: $font-color;
    display: flex;
    flex-direction: column;
    font-size: 17px;

    img {
      border-radius: 9px;
      max-width: 300px;
    }

    &.outside {
      margin-left: -200%;
      position: absolute;
    }

    &.skip,
    & .skip {

      .left,
      &.left {
        padding: 0px 20px;
        align-items: center;
      }

      img {
        margin: 12px 0;
        margin-left: 30px;
        border-radius: 130px;
      }
    }

    .button-remote-skip {
      width: fit-content;

      &:hover {
        text-decoration: underline;
      }
    }

    .error {
      color: $red;
    }

    .left,
    .right {
      border-radius: 1.15rem;
      padding: 23px 29px;
      position: relative;
      line-height: 30px;
      word-wrap: break-word;
      width: max-content;
      max-width: 60%;

      &::before,
      &::after {
        bottom: -0.1rem;
        content: "";
        height: 1rem;
        position: absolute;
      }

      .info {
        font-size: 21px;
        color: $green-2;
        font-weight: bold;
      }

      .options {
        margin-top: 30px;
      }
    }

    .left {
      align-items: flex-start;
      background: white;
      border-right: 4px solid #ccc;
      border-bottom: 3px solid #ccc;
      margin: 12px 150px;

      @media (max-width: $small) {
        margin: 12px 35px;
        max-width: 70%;
      }

      &::before {
        border-bottom-right-radius: 0.8rem 0.7rem;
        border-left: 1rem solid white;
        left: -0.35rem;
        transform: translate(0, -0.1rem);
      }

      &:after {
        background-color: $white-3;
        border-bottom-right-radius: 0.5rem;
        left: 20px;
        transform: translate(-30px, -2px);
        width: 10px;
      }
    }

    .right {
      align-self: flex-end;
      background: $supporter-1;
      border-left: 4px solid #ccc;
      border-bottom: 3px solid #ccc;
      color: white;
      margin: 12px 150px;

      @media (max-width: $small) {
        margin: 12px 12px;
        max-width: 70%;
      }

      &::before {
        border-bottom-left-radius: 0.8rem 0.7rem;
        border-right: 1rem solid $supporter-1;
        right: -0.3rem;
        transform: translate(0, -0.1rem);
      }

      &::after {
        background-color: $white-3;
        border-bottom-left-radius: 0.5rem;
        right: -40px;
        transform: translate(-30px, -2px);
        width: 10px;
      }
    }
  }

  .buttons {
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 90%;
    height: 100px;
    padding-right: 10%;
    background: $white-3;
    padding-bottom: 20px;

    &.out {
      bottom: -200px;
    }

    @media (max-width: $small) {
      padding-right: 0%;
      width: 100%;
    }

    input {
      margin: 9px;
      margin-bottom: 0px;
      margin-left: 140px;
      border: none;
      background: none;
      border-radius: 21px;
      border-bottom: 3px solid #666;
      font-size: 19px;
      padding: 16px 28px;
      color: $green-5;
      letter-spacing: 1.3px;
      font-weight: bold;

      &:focus {
        background: none !important;
        color: $supporter-1;
        border-bottom: 5px solid $supporter-1;
      }

      @media (max-width: $small) {
        margin: 13px;
        margin-left: 10px;
      }
    }

    i {
      font-size: 48px;
      margin: 30px;
      margin-top: 33px;
      margin-left: -22px;
      color: $gray-2;
      cursor: pointer;

      &:hover {
        color: $supporter-1;
      }

      @media (max-width: $small) {
        margin: 26px;
        margin-left: 0px;
      }
    }
  }
}
</style>